// extracted by mini-css-extract-plugin
export default {"modal":"booking_modal__JHKzN"};